// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2WPfx","footer":"ModalUpdate_footer__2xd0d"};